import axios from 'axios';
import { Injectable } from '@angular/core';
import { environment as env } from '../environments/environment';
import { BrowserService } from './browser.service';

@Injectable({ providedIn: 'root' })
export class UploadService {
  private url = `${env.apiUrl}upload`;

  constructor(
    private _browserService: BrowserService
  ) { }

  public async upload(file?: File, folder?: string, config?: any) {
    try {
      const token = this._browserService.getSessionStorage()?.getItem('token')
      const query = `?contentType=${file?.type}&filename=${file?.name}&folder=${folder}`;
      const uploadUrl = `${this.url}${query}`;
      const data = await axios.get(uploadUrl, {
        withCredentials: true,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      await axios.put(data.data.url, file, config);
      return data.data.url.split("?")[0];
    } catch (error) {
      throw error;
    }
  }
}